<template>
  <a-modal
    title="编辑优惠券"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
        <a-form-item
          label="劵编号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入劵编号" v-decorator="['code', {rules: [{required: true, message: '请输入劵编号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="券名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入券名称" v-decorator="['name', {rules: [{required: true, message: '请输入券名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        </a-form-item>
        <a-form-item
          label="兑换码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入兑换码" v-decorator="['exchangeCode', {rules: [{required: true, message: '请输入兑换码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="有效期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择有效期" v-decorator="['vaildDate',{rules: [{ required: true, message: '请选择有效期！' }]}]" @change="onChangevaildDate"/>
        </a-form-item>
        <a-form-item
          label="状态  0：未激活  1：已激活  2：已使用 3：已过期  4：已删除"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入状态  0：未激活  1：已激活  2：已使用 3：已过期  4：已删除" v-decorator="['status', {rules: [{required: true, message: '请输入状态  0：未激活  1：已激活  2：已使用 3：已过期  4：已删除！'}]}]" />
        </a-form-item>
        <a-form-item
          label="使用标记（0-停用 1-使用）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入使用标记（0-停用 1-使用）" v-decorator="['useflag', {rules: [{required: true, message: '请输入使用标记（0-停用 1-使用）！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { buCouponEdit } from '@/api/modular/interhospital/bucoupon/buCouponManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        vaildDateDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              id: record.id,
              code: record.code,
              name: record.name,
              amount: record.amount,
              exchangeCode: record.exchangeCode,
              status: record.status,
              useflag: record.useflag
            }
          )
        }, 100)
        // 时间单独处理
        if (record.vaildDate != null) {
            this.form.getFieldDecorator('vaildDate', { initialValue: moment(record.vaildDate, 'YYYY-MM-DD') })
        }
        this.vaildDateDateString = moment(record.vaildDate).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.vaildDate = this.vaildDateDateString
            buCouponEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangevaildDate(date, dateString) {
        this.vaildDateDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
